import type { RootState } from 'store';

export const adminModuleCountSelector = (state: RootState) => state.admin.adminModuleCount.counts;
